import "../styles/LabelModal.css";
import { apiRequest } from "../utils/api"; // apiRequestのインポート
import React, { useState, useEffect, useRef } from "react";

const LabelModal = ({ isOpen, onClose, labelId, setCount, setIsModalOpen }) => {
  const [inputs, setInputs] = useState([]);
  
  // 最初の入力フィールドを参照するためのref
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (setCount > 1) {
      setInputs(new Array(setCount - 1).fill(""));
    }
  }, [setCount]);

  // モーダルが開いた時に最初の入力フィールドにフォーカスを当てる
  useEffect(() => {
    if (isOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [isOpen]);

  const handleInputChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (index < inputs.length - 1) {
        document.getElementById(`input-${index + 1}`).focus();
      } else {
        handleSubmit();
      }
    }
  };

  const handleSubmit = async () => {
    // JANコード（カンマ区切り）を入力データから取得
    const janCodes = inputs.join(",");

    try {
      const response = await apiRequest("inventory/submit_setid/", "POST", {
        id: labelId,  // PriceLabelのID
        jan: janCodes,  // 入力されたJANコード
      });

      if (response.message === "成功") {
        onClose();  // モーダルを閉じる
      } else {
        console.error("エラー:", response.message);
      }
    } catch (error) {
      console.error("APIリクエストエラー:", error);
    }
  };

  if (!isOpen) return null;

  // モーダルを閉じる
  const closeModal = (event) => {
    // クリックされたターゲットがモーダル本体（モーダル外）であることを確認
    if (event.target === event.currentTarget) {
      setIsModalOpen(false);  // モーダルを閉じる
    }
  };

  return (
    <div className="modal" onClick={closeModal}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h3>バーコード入力</h3>
        <div id="inputContainer">
          {inputs.map((input, index) => (
            <div key={index}>
              <input
                id={`input-${index}`}
                ref={index === 0 ? firstInputRef : null}  // 最初のinputにフォーカス用refを設定
                type="text"
                className="input-box"
                placeholder={`JAN ${index + 1}`}
                value={input}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            </div>
          ))}
        </div>
        <button onClick={handleSubmit}>確定</button>
      </div>
    </div>
  );
};

export default LabelModal;
